module.exports = __webpack_public_path__ + "img/0b4cf37ce26a2566e3209f2661991841.png";